import {Row} from "antd";
import PurchaseCartCard from "./PurchaseCartCard";
import {useMemo, useState} from "react";
import PurchaseCartModal from "./PurchaseCartModal";
import {epochToDate} from "../../../shared/functions/toDateTime";
import { Avatar, Grid, IconButton, TextField} from '@material-ui/core'; 

import {nanoid} from "@reduxjs/toolkit";
import PurchaseCartDetails from "./PurchaseCartDetails";

export default function PurchaseCartList({items}) {
    const [isModalShown, setIsModalShown] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    
    const list = useMemo(() => {
        if (!items) return [];
        
        
        console.log(items);
        return items.map(item => { 
            return ({
                id: item.id,
                ref: item.CartRef,
                VendorName: item.Name,
                Show:item.Show ? item.Show : 'off',
                Validation:item.Validation ? item.Validation : 'no',
                Urgents:item.Urgents ? item.Urgents : 'no'

            })
        })
        
    }, [items])

    // console.log( "lmllllml", items.cost);
    


    const handleModalOpening = () => setIsModalShown(true);
    const handleModalClosing = () => {
        setIsModalShown(false);
        setSelectedItem(null)
    }

    const handleSelection = (id) => {
        //console.log(" ==> "+ id);
        items && setSelectedItem(items.find(one => one.id === id))
        handleModalOpening()
    }

    return (
        <>
         <section>
         <Grid container spacing={2} style={{padding: 20}}>
            <Grid item> 
               <TextField margin="dense" variant="outlined" name="name" value={""}
                 label="Rechercher un vendor ..."/>
            </Grid>
          </Grid>
            <Row>
                {
                    list && list.map(item => (
                        <PurchaseCartCard
                            key={nanoid()}
                            item={item}
                           
                            onClick={() => handleSelection(item.id)}
                        />
                    ))
                }
            </Row>

            {
                selectedItem && (
                    <PurchaseCartDetails 
                    handleClose={handleModalClosing}
                    frontCart={selectedItem} />
                    /*<POModal
                        items={selectedItem}
                        show={isModalShown}
                        onClose={handleModalClosing}
                    />*/
                )
            }

            <section>

            </section>

        </section>  
       
        </>
       
    )    
}
